import { cva } from "class-variance-authority"

/**
 * Mirrors `selectTriggerVariants` so a `MultiSelect` placed next to a
 * `Select` in a form / filter popover has identical chrome (height, font,
 * padding, border treatment). Keep the variant + size axes locked to the
 * Select shape — diverging here is the surest way to ship visually
 * inconsistent forms.
 */
export const multiSelectTriggerVariants = cva(
  "ui-multi-select-trigger text-foreground flex w-full items-center justify-between whitespace-nowrap rounded-md ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
  {
    variants: {
      variant: {
        outline: "border border-input bg-transparent shadow-sm",
        secondary:
          "bg-secondary text-secondary-foreground border border-transparent",
        ghost: "border border-transparent",
      },
      size: {
        tiny: "h-6 text-xs px-2 py-1 rounded-sm",
        xs: "h-7 text-sm px-2 py-1 rounded-sm",
        sm: "h-8 text-sm px-3 py-1.5 rounded-sm",
        md: "h-9 text-sm px-3 py-2",
        lg: "h-10 text-base px-3 py-2",
      },
    },
    defaultVariants: {
      variant: "outline",
      size: "md",
    },
  },
)

/**
 * Threshold above which the dropdown shows a search input. Items below
 * this stay scannable without a search; above it, the user wants to
 * filter rather than scroll. `8` matches the design conventions in
 * `command/Command.tsx` for "shortlist" vs "browse" sizing.
 */
export const MULTI_SELECT_SEARCH_THRESHOLD = 8
